// @ts-ignore
import Vue from "vue";
// @ts-ignore
import AOS from 'aos';
import AmbassadorProjects from "../components/AmbassadorProjects/AmbassadorProjects";

namespace NHW.controllers.workbenchArticle {
	function initializeProjects() {
		if(document.getElementById('ambassadorProjects')) {
			new Vue({
				created () {
					AOS.init({startEvent: 'load'})
				},
				render: h => h(AmbassadorProjects)
			}).$mount('#ambassadorProjects');
		}
	}

	export function init() {		
		initializeProjects();
	}
}

document.addEventListener('DOMContentLoaded', function(e) { 
	NHW.controllers.workbenchArticle.init();
});

